module.exports = __webpack_public_path__ + "static/video_cover-541d8f81fd3b6595eede94cb04d8d816.jpg";